<div class="engine-scrubber">
  <button app-button
    *ngIf="showPlay"
    [buttonTheme]="theme"
    buttonSize="small" 
    class="engine-scrubber__play"
    [ngClass]="{'mr-4': showScrubber}"
    (click)="handlePlayClick()">
    <app-button-icon label="Play" iconPlacement="left" icon="play" *ngIf="!(animationPlaying$ | async)"></app-button-icon>
    <app-button-icon label="Pause" iconPlacement="left" icon="pause" *ngIf="(animationPlaying$ | async)"></app-button-icon>
  </button>
    
  <input
    *ngIf="showScrubber"
    class="engine-scrubber__input"
    type="range"
    style="width: 100%" 
    [(ngModel)]="percent" 
    (mousedown)="handleInputMouseDown()"
    (mouseup)="handleInputMouseUp()"
    min="0" 
    max="100">
</div>
